import {
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState, useTransition } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AddLeaveRequestAction,
  GetLeaveRequestAction,
} from "../../../../../../store/Leave/LeaveRequest/Action";
import CommonDatePicker from "../../../../Base/views/CommonDatePicker";
import SelectableSearch from "../../../../Base/views/SelectableSearch";
import {
  ConvertDate,
  getEmployeeId,
  getUserData,
} from "../../../../Base/helper/baseFunctions";
import ViewHolidayCalendar from "../../../../Leave/views/ManageLeave/ApplyLeave/HolidayCalendar";
import { GetLeaveOverallBalanceAction } from "../../../../../../store/Leave/LeaveDashboard/Action";
import { GetHolidayCalendarAction } from "../../../../../../store/Leave/HolidayCalendar/Action";
import { GetLeaveReasonAction } from "../../../../../../store/Leave/LeaveReason/Action";
import { GetYearlyHolidayCalendarAction } from "../../../../../../store/Leave/YearlyHolidayCalendar/Action";
import { GetWeekOffConfigureAction } from "../../../../../../store/Leave/WeekOff/Action";
import { GetEmployeeOptionalHolidayCalendarAction } from "../../../../../../store/Leave/OptionalHolidayCalendar/Action";
import { GetEmployeesAction } from "../../../../../../store/Employee/Employee/Action";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
var getDaysArray = function (s, e) {
  for (
    var a = [], d = new Date(s);
    d <= new Date(e);
    d.setDate(d.getDate() + 1)
  ) {
    a.push(new Date(d));
  }
  return a;
};

const ApplyLeave = ({ setOpenPopup, my_time_off, setFlag, team_time_off }) => {

  const initialFValues = {
    employee_id: "",
    leavetype_id: "",
    year: "",
    requested_days: "",
    from_date: null,
    is_from_half: false,
    to_date: null,
    is_to_half: false,
    status: team_time_off ? "Approved" : "Submitted",
    note: "",
    leave_proof: "", //TODO
    lta_availed: false,
    is_from_half_value: "",
    is_to_half_value: "",
    leave_balance: "",
    leave_reason: "",
    compoff_date_mapping_json: null,
  };

  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const { leaveOverallBalanceData } = useSelector(
    (state) => state.LeaveReducer.LeaveDashboardReducer
  );

  const { leaveRequestData, addSuccess } = useSelector(
    (state) => state?.LeaveReducer.LeaveRequestReducer
  );
  const { holidayCalendarData } = useSelector(
    (state) => state.LeaveReducer.HolidayCalendarReducer
  );
  const { leavereasonData } = useSelector(
    (state) => state.LeaveReducer.LeaveReasonReducer
  );
  const { dashboardData } = useSelector(
    (state) => state?.EmployeeDashboardReducer
  );
  const { holidayData } = useSelector(state => state?.LeaveReducer?.YearlyHolidayCalendarReducer); // Public holiday configured in settings
  let dashboard = dashboardData?.[0]?.reporting_manager_info?.[0];
  const { employees_options } = useSelector(
    (state) => state.EmployeeReducer.EmployeesReducer,
  );
  const { week_off_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);
  const { employeeOptionalHolidayData } = useSelector((state) => state.LeaveReducer?.OptionalHolidayCalendarReducer);
  const [employeeData, setEmployeeData] = useState({
    load: true,
    values: [],
  });

  const [leaveTypesData, setLeaveTypesData] = useState({
    load: true,
    values: [],
  });
  const [leaveReasonData, setLeaveReasonData] = useState({
    load: true,
    values: [],
  });
  const [errors, setErrors] = useState({});
  const [leaveRequestModalData, setLeaveRequestModalData] =
    useState(initialFValues);
  const isCompOffSelected = leaveRequestModalData?.leavetype_id?.leavetype_name === 'Compensatory Off';

  const formatDateYMD = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${("0" + d.getDate()).slice(-2)}`;
  };

  const formatDateDDMMYYYY = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`;
  };

  const [reqDays, setReqDays] = useState(0);
  const [, startTransition] = useTransition();
  const [opensPopup, setOpensPopup] = useState(false);
  const empData = getUserData();

  let public_Holiday = [];
  holidayData?.map((hc) => {
    if (hc?.date) {
      public_Holiday.push(new Date(hc.date).toLocaleDateString());
    }
    return "";
  });

  let optional_Holiday = [];
  employeeOptionalHolidayData?.map((ophc) => {
    if (ophc?.date) {
      optional_Holiday.push(new Date(ophc?.date).toLocaleDateString());
    }
    return "";
  });

  const empLeaveMap = {}; // leave taken and approved dates
  const allCompoffDateMappings = {}; //comp-off consumed dates

  leaveRequestData?.forEach((l) => {
    if (l?.status === "Approved" && l?.from_date) {
      const dateKey = new Date(l.from_date).toLocaleDateString();

      if (!empLeaveMap[dateKey]) {
        empLeaveMap[dateKey] = {
          full: false,
          firstHalf: false,
          secondHalf: false,
        };
      }

      if (l?.requested_days === 1) {
        empLeaveMap[dateKey].full = true;
      } else if (l?.requested_days === 0.5) {
        if (l.is_from_half) {
          if (l.is_from_half_value === "First Half") {
            empLeaveMap[dateKey].firstHalf = true;
          }
          if (l.is_from_half_value === "Second Half") {
            empLeaveMap[dateKey].secondHalf = true;
          }
        }

        if (l.is_to_half) {
          if (l.is_to_half_value === "First Half") {
            empLeaveMap[dateKey].firstHalf = true;
          }
          if (l.is_to_half_value === "Second Half") {
            empLeaveMap[dateKey].secondHalf = true;
          }
        }
        if (empLeaveMap[dateKey].firstHalf && empLeaveMap[dateKey].secondHalf) {
          empLeaveMap[dateKey].full = true;
        }
      }

    if (l?.compoff_date_mapping_json && l?.leavetype === "Compensatory Off") {
      let parsedMapping = l?.compoff_date_mapping_json;
      if (typeof parsedMapping === "string") {
        try {
          parsedMapping = JSON.parse(parsedMapping);
        } catch (error) {
          parsedMapping = {};
        }
      }
      Object.entries(parsedMapping || {}).forEach(([leaveDate, workedDate]) => {
        if (workedDate) {
          allCompoffDateMappings[workedDate] = leaveDate; // only key is usefull
        }
      });
    }
    }
  });
  const getLeaveForDate = (dateStr) => {
    if (!dateStr) return null;
    return empLeaveMap[new Date(dateStr).toLocaleDateString()];
  };
  const fromLeave = getLeaveForDate(leaveRequestModalData.from_date);
  const toLeave = getLeaveForDate(leaveRequestModalData.to_date);

  holidayCalendarData?.map((hc) => {
    if (hc?.date) {
      public_Holiday.push(new Date(hc.date).toLocaleDateString());
    }
    return "";
  });
  var disableApply =
    (leaveRequestModalData?.is_from_half &&
      leaveRequestModalData?.is_from_half_value === "") ||
    (leaveRequestModalData?.is_to_half &&
      leaveRequestModalData?.is_to_half_value === "")

  useEffect(() => {
    dispatch(GetYearlyHolidayCalendarAction({ year: 0 }));
    dispatch(GetLeaveOverallBalanceAction({ show: "no" }));
    dispatch(GetWeekOffConfigureAction());
    dispatch(GetLeaveRequestAction({ show: "no" }));
    dispatch(
      GetHolidayCalendarAction({
        city_id: empData?.city_id,
        year: new Date().getFullYear(),
        show: "no",
      })
    );
    dispatch(GetEmployeeOptionalHolidayCalendarAction({ year: 0, employee_fk: getEmployeeId() }));
    //eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    dispatch(GetEmployeesAction({ is_active: true }));
    setLeaveRequestModalData({
      ...leaveRequestModalData,
      employee_id: team_time_off ? "" : empData?.employee_id,

    });
    if (addSuccess) {
      setLeaveRequestModalData({
        ...initialFValues,
        employee_id: team_time_off ? "" : empData?.employee_id,
      });
      dispatch(GetLeaveOverallBalanceAction({ show: "no" }));
      dispatch(GetLeaveRequestAction({ show: "no" }));
      dispatch(
        GetHolidayCalendarAction({
          city_id: empData?.city_id,
          year: new Date().getFullYear(),
          show: "no",
        })
      );
    }
    if (addSuccess && success) {
      setOpenPopup(false)
      if (my_time_off) {
        setFlag(true)
      }
    }

    dispatch(GetLeaveReasonAction());

    //eslint-disable-next-line
  }, [addSuccess]);

  var daylist =
    leaveRequestModalData?.from_date && leaveRequestModalData?.to_date
      ? getDaysArray(
        new Date(leaveRequestModalData?.from_date),
        new Date(leaveRequestModalData?.to_date)
      )
      : [];

  function getDayName(dayIndex) {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return daysOfWeek[dayIndex];
  }
  const checkWorkingDay = (date) => {
    const dayOfWeek = date.getDay();
    const weekOff = week_off_data?.find(
      (weekOffItem) => weekOffItem.day_name === getDayName(dayOfWeek)
    );
    return weekOff
  }

  let disableSaturday = false;
  function disableDates(date) {
    const key = date.toLocaleDateString();
    const leave = empLeaveMap[key];
    const holidayInfo = isHolidayDate(date);
    if (disableSaturday) {
      return [0, 6].includes(date.getDay()) || leave?.full;
    } else {
      return holidayInfo?.isFullHoliday || leave?.full;
    }
  }

  const isHolidayDate = (date) => {
    if (!date) return null;
    const dateKey = date.toLocaleDateString();
    if (public_Holiday?.includes(dateKey) || holidayData?.some((holiday) => new Date(holiday.date).toLocaleDateString() === dateKey)) {
      return { statusText: 'Public Holiday', isFullHoliday: true };
    }
    if (optional_Holiday?.includes(dateKey) || employeeOptionalHolidayData?.some((optHoliday) => new Date(optHoliday.date).toLocaleDateString() === dateKey)) {
      return { statusText: 'Optional Holiday', isFullHoliday: true };
    }
    const dayOfWeek = date.getDay();
    const weekOff = week_off_data?.find(
      (weekOff) => weekOff.day_name === getDayName(dayOfWeek)
    );
    if (weekOff) {
      return {
        statusText: weekOff.full_day_off ? 'Holiday(1)' : 'Holiday(0.5)',
        isFullHoliday: Boolean(weekOff.full_day_off),
      };
    }
    if (disableSaturday && date.getDay() === 6) {
      return { statusText: 'Holiday', isFullHoliday: true };
    }
    return null;
  };

  const disableWorkedDates = (date, currentLeaveDate) => {
    const holidayInfo = isHolidayDate(date);
    if (!holidayInfo?.isFullHoliday) return true;

    const mapping = leaveRequestModalData?.compoff_date_mapping_json || {};
    const formattedDate = formatDateYMD(date);
    const formattedCurrentLeaveDate = formatDateYMD(currentLeaveDate);

    for (const [leaveDateKey, workedDateValue] of Object.entries(mapping)) {
      if (leaveDateKey !== formattedCurrentLeaveDate && workedDateValue === formattedDate) {
        return true;
      }
    }
    return false;
  };

  const isCompOffMappingComplete = (mapping = leaveRequestModalData?.compoff_date_mapping_json || {}) => {
    if (!isCompOffSelected) return true;
    return daylist.every((date) => {
      const key = date.toLocaleDateString();
      const leave = empLeaveMap[key];
      const isHoliday = isHolidayDate(date);
      const isWorkingDay = !isHoliday && !leave;
      return !isWorkingDay || Boolean(mapping[formatDateYMD(date)]);
    });
  };

  const getCompoffHolidayOptions = (currentLeaveDate) => {
    if (!currentLeaveDate) {
      return [];
    }

    const startDate = new Date(new Date().setMonth(new Date().getMonth() - 2));
    const endDate = new Date();
    const options = [];

    for (let dt = new Date(startDate); dt <= endDate; dt.setDate(dt.getDate() + 1)) {
      const date = new Date(dt);
      const formattedDate = formatDateYMD(date);

      if (allCompoffDateMappings[formattedDate]) {  // eliminate the comp-off consumed dates
        continue;
      }

      if (!disableWorkedDates(date, currentLeaveDate)) { // only holiday dates as option
        options.push({
          value: formattedDate,
          label: formatDateDDMMYYYY(date),
        });
      }
    }

    return options;
  };

  const handleWorkedDateChange = (leaveDate, workedDate) => {
    const leaveDateKey = formatDateYMD(leaveDate);
    const workedDateValue = workedDate ? formatDateYMD(workedDate) : null;

    const currentMapping = leaveRequestModalData.compoff_date_mapping_json || {};
    const updatedMapping = {
      ...currentMapping,
      [leaveDateKey]: workedDateValue,
    };

    setLeaveRequestModalData({
      ...leaveRequestModalData,
      compoff_date_mapping_json: updatedMapping,
    });

    if (errors.compoff_date_mapping_json && isCompOffMappingComplete(updatedMapping)) {
      setErrors({
        ...errors,
        compoff_date_mapping_json: "",
      });
    }
  };
  
  const calculateRequestedDate = (event) => {
    if (["is_from_half", "is_to_half"].includes(event?.target?.name)) {
      if (
        event.target.name === "is_from_half" &&
        event.target.checked === false
      ) {
        setLeaveRequestModalData({
          ...leaveRequestModalData,
          [event.target.name]: event.target.checked,
          is_from_half_value: "",
        });
      } else if (
        event.target.name === "is_to_half" &&
        event.target.checked === false
      ) {
        setLeaveRequestModalData({
          ...leaveRequestModalData,
          [event.target.name]: event.target.checked,
          is_to_half_value: "",
        });
      } else {
        setLeaveRequestModalData({
          ...leaveRequestModalData,
          [event.target.name]: event.target.checked,
          [`${event.target.name}_value`]:
            event.target.name === "is_from_half" ? "Second Half" : "First Half",
        });
      }
    } else {
      setLeaveRequestModalData({
        ...leaveRequestModalData,
        [event.target.name]: event.target.value,
        is_to_half: false,
        is_to_half_value: "",
        is_from_half: false,
        is_from_half_value: "",
        compoff_date_mapping_json: null,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({
          ...leaveRequestModalData,
          [event.target.name]: event.target.value,
        });
    }

    startTransition(() => {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(
        event.target.name === "to_date"
          ? event.target.value
          : leaveRequestModalData?.to_date || ""
      );
      const secondDate = new Date(
        event.target.name === "from_date"
          ? event.target.value
          : leaveRequestModalData?.from_date || ""
      );
      var diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      setReqDays(diffDays + 1);
      if (event?.target?.name === "is_from_half" && event?.target?.checked) {
        setReqDays(reqDays - 0.5);
      } else if (
        event?.target?.name === "is_from_half" &&
        event?.target?.checked === false
      ) {
        setReqDays(reqDays + 0.5);
      }
      if (event?.target?.name === "is_to_half" && event?.target?.checked) {
        setReqDays(reqDays - 0.5);
      } else if (
        event?.target?.name === "is_to_half" &&
        event?.target?.checked === false
      ) {
        setReqDays(reqDays + 0.5);
      }
    });
  };
  const handleEmployees = () => {
    employees_options && setEmployeeData({ load: false, values: employees_options });
  };
  const calculateToHoliday = (event) => {
    var t = 0;
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(
      event.target.name === "to_date"
        ? event.target.value
        : leaveRequestModalData?.to_date || ""
    );
    const secondDate = new Date(
      event.target.name === "from_date"
        ? event.target.value
        : leaveRequestModalData?.from_date || ""
    );
    var diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

    if (
      leaveRequestModalData?.from_date !== null &&
      new Date(event?.target?.value) >
      new Date(leaveRequestModalData?.from_date)
    ) {
      for (
        var dt = new Date(leaveRequestModalData?.from_date);
        dt <= new Date(event?.target?.value);
        dt.setDate(dt.getDate() + 1)
      ) {
        const key = dt.toLocaleDateString();
        const leave = empLeaveMap[key];
        if (public_Holiday?.includes(dt.toLocaleDateString())) {
          t = t + 1;
        } else if (optional_Holiday?.includes(dt.toLocaleDateString())) {
          t = t + 1;
        } else if (leave?.full || (leave?.firstHalf && leave?.secondHalf)) {
          t = t + 1;
        } else if (leave?.firstHalf || leave?.secondHalf) {
          t = t + 0.5;
        }
        else if (week_off_data.length > 0) {
          const weekdayName = dt.toLocaleString('en-us', { weekday: 'long' });
          const weekDay = week_off_data?.find(
            (weekOff) => weekOff.day_name === weekdayName
          );
          if (weekDay) {
            if (weekDay.full_day_off) {
              t = t + 1
            }
            else {
              t = t + 0.5
            }
          }
        }
      }
      setReqDays(diffDays - t + 1);
    }
    else if (leaveRequestModalData?.from_date !== null &&
      new Date(event?.target?.value)?.getTime() ===
      new Date(leaveRequestModalData?.from_date)?.getTime() && (checkWorkingDay(firstDate)?.half_day_off)) {
      setReqDays(0.5)
    }
  };

  const calculateFromHoliday = (event) => {
    var t = 0;
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(
      event.target.name === "to_date"
        ? event.target.value
        : leaveRequestModalData?.to_date || ""
    );
    const secondDate = new Date(
      event.target.name === "from_date"
        ? event.target.value
        : leaveRequestModalData?.from_date || ""
    );
    var diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

    if (
      leaveRequestModalData?.to_date !== null &&
      new Date(event?.target?.value) < new Date(leaveRequestModalData?.to_date)
    ) {
      for (
        var dt = new Date(event?.target?.value);
        dt <= new Date(leaveRequestModalData?.to_date);
        dt.setDate(dt.getDate() + 1)
      ) {
        const key = dt.toLocaleDateString();
        const leave = empLeaveMap[key];
        if (public_Holiday?.includes(dt.toLocaleDateString())) {
          t = t + 1;
        } else if (optional_Holiday?.includes(dt.toLocaleDateString())) {
          t = t + 1;
        } else if (leave?.full || (leave?.firstHalf && leave?.secondHalf)) {
          t = t + 1;
        } else if (leave?.firstHalf || leave?.secondHalf) {
          t = t + 0.5;
        } else if (week_off_data.length > 0) {
          const currentDayName = dt.toLocaleString('en-us', { weekday: 'long' });
          const weekDay = week_off_data?.find(
            (weekOff) => weekOff.day_name === currentDayName
          );
          if (weekDay) {
            if (weekDay.full_day_off) {
              t = t + 1
            }
            else {
              t = t + 0.5
            }
          }
        }
      }
      setReqDays(diffDays - t + 1);
    }
    else if (leaveRequestModalData?.to_date !== null &&
      new Date(event?.target?.value)?.getTime() === new Date(leaveRequestModalData?.to_date)?.getTime()
      && (checkWorkingDay(firstDate)?.half_day_off)) {
      setReqDays(0.5)
    }
  };

  const handleInputChange = (event, value) => {
    if (
      ["primary_approver_id", "sec_approver_id", "leave_reason",].includes(event)
    ) {
      if (value) {
        setLeaveRequestModalData({ ...leaveRequestModalData, [event]: value });
      } else {
        setLeaveRequestModalData({ ...leaveRequestModalData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...setLeaveRequestModalData, [event]: value ? value : "" });
    } else if (event === "employee_id") {
      if (value) {
        setLeaveRequestModalData({ ...leaveRequestModalData, [event]: value });
        dispatch(GetLeaveOverallBalanceAction({ show: "no", emp_user_id: value?.emp_users }));
        dispatch(GetLeaveRequestAction({ show: "no", emp_user_id: value?.emp_users }));
        dispatch(GetEmployeeOptionalHolidayCalendarAction({ year: 0, employee_fk: value?.employee_id }));
      } else {
        setLeaveRequestModalData({ ...leaveRequestModalData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...setLeaveRequestModalData, [event]: value ? value : "" });
    }
    else if (event === "leavetype_id") {
      if (value) {
        setLeaveRequestModalData({
          ...leaveRequestModalData,
          [event]: value,
          from_date: null,
          to_date: null,
          leave_reason: "",
          compoff_date_mapping_json: null,
        });
      } else {
        setLeaveRequestModalData({
          ...leaveRequestModalData,
          [event]: "",
          from_date: null,
          to_date: null,
          leave_reason: "",
          compoff_date_mapping_json: null,
        });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...setLeaveRequestModalData, [event]: value ? value : "" });
    } else if (event?.target?.name === "lta_availed") {
      setLeaveRequestModalData({
        ...leaveRequestModalData,
        [event.target.name]: event.target.checked,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({
          ...leaveRequestModalData,
          [event.target.name]: event.target.checked,
        });
    } else {
      setLeaveRequestModalData({
        ...leaveRequestModalData,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({
          ...leaveRequestModalData,
          [event.target.name]: event.target.value,
        });
    }
  };
  const handleSetLeaveType = () => {
    if (empData?.gender === "Female") {
      setLeaveTypesData({
        load: false,
        values: leaveOverallBalanceData?.filter((pt) => pt.gender !== "Male"),
      });
    } else if (empData?.gender === "Male") {
      setLeaveTypesData({
        load: false,
        values: leaveOverallBalanceData?.filter((pt) => pt.gender !== "Female"),
      });
    } else {
      setLeaveTypesData({ load: false, values: leaveOverallBalanceData });
    }
  };

  const handleSetLeaveReason = () => {
    setLeaveReasonData({ load: false, values: leavereasonData });
  };

  const validate = (fieldValues = leaveRequestModalData) => {
    let temp = { ...errors };

    if ("employee_id" in fieldValues) {
      temp.employee_id =
        fieldValues.employee_id === "" ? "Employee is required" : "";
    }
    if ("leavetype_id" in fieldValues) {
      temp.leavetype_id =
        fieldValues.leavetype_id === "" ? "Leave Type is required" : "";
    }
    if ("from_date" in fieldValues) {
      temp.from_date =
        fieldValues.from_date === ("" || null) ? "From Date is required" : "";
    }
    if ("to_date" in fieldValues) {
      temp.to_date =
        fieldValues.to_date === ("" || null) ? "To Date is required" : "";
    }
    if ("leave_reason" in fieldValues) {
      temp.leave_reason =
        fieldValues.leave_reason === "" &&
          leaveRequestModalData?.leavetype_id?.is_unlimited
          ? "Leave Reason is required"
          : "";
    }
    if ("note" in fieldValues) {
      temp.note =
        fieldValues.note === "" ? "Reason is required" : "";
    }
    if ("compoff_date_mapping_json" in fieldValues && isCompOffSelected) {
      temp.compoff_date_mapping_json =
        !isCompOffMappingComplete() ? "Please select a Comp-Off Earned On date for all working days." : "";
    } else {
      temp.compoff_date_mapping_json = "";
    }

    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };
  const handleSubmit = async (event) => {
    if (event.type === "click" || event.which === 13) {
      if (validate()) {
        dispatch(
          AddLeaveRequestAction({
            ...leaveRequestModalData,
            year: new Date(leaveRequestModalData?.from_date).getFullYear(),
            employee_id: team_time_off ? leaveRequestModalData?.employee_id?.employee_id : empData?.employee_id,
            reqDays,
            dashboard,
            employee: team_time_off ? leaveRequestModalData?.employee_id?.name : empData?.name,
            office_email: team_time_off ? leaveRequestModalData?.employee_id?.email : empData?.office_email,
            compoff_date_mapping_json: isCompOffSelected ? Object.keys(leaveRequestModalData?.compoff_date_mapping_json).length > 0 ? JSON.stringify(leaveRequestModalData?.compoff_date_mapping_json) : null : null,
          })
        );
        setSuccess(true)
      }
    }
  };

  const handleConfirmationAlert = (event) => {
    handleSubmit(event);
  };
  const checkLeaveBalance = (isCompOff) => {
    if (isCompOff) {
      return { canBook: true };
    }
    const currentBal = leaveRequestModalData?.leavetype_id?.available_days || 0;
    const effective = isNaN(reqDays) || !(leaveRequestModalData?.from_date && leaveRequestModalData?.to_date) ? 0 : reqDays;
    const remaining = currentBal - effective;
    if (remaining < 0) {
      return {
        canBook: false,
      };
    }
    return { canBook: true };
  };
  const { canBook } = checkLeaveBalance(isCompOffSelected);

  return (
    <Box>
      <div className="leave-holiday-calendar">
        {opensPopup && (
          <ViewHolidayCalendar
            openPopup={opensPopup}
            setOpenPopup={setOpensPopup}
          />
        )}
        <Grid container paddingBottom={"10px"}>
          <Grid item xs={12} md={7} padding={"10px"}>
            <Grid container>
              <Grid
                key="employee_id"
                item
                xs={12}
                md={12}
                sx={{
                  marginTop: "1rem",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                }}
              >
                {team_time_off ? (
                  <SelectableSearch
                    isOptionEqualToValue={(option, value) =>
                      +option.employee_id ===
                      +value.employee_id
                    }
                    label="Employee"
                    value={leaveRequestModalData?.employee_id}
                    loading={() => handleEmployees()}
                    fieldLabel="name"
                    required
                    variant={"contained"}
                    name="employee_id"
                    size="small"
                    data={employeeData}
                    onChangeEvent={handleInputChange}
                    {...(errors.employee_id && {
                      error: true,
                      helperText: errors.employee_id,
                    })}
                  />
                ) : (
                  <FormControl fullWidth>
                    <TextField
                      value={empData?.name}
                      variant="outlined"
                      type={"text"}
                      fullWidth
                      size="small"
                      id="note"
                      label="Employee Name"
                      name="note"
                      disabled={true}
                    />
                  </FormControl>
                )}
              </Grid>
              <Grid
                key="leavetype_id"
                item
                xs={12}
                md={12}
                sx={{
                  marginTop: "1rem",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                }}
              >
                <FormControl fullWidth>
                  <SelectableSearch
                    label="Leave Type"
                    value={leaveRequestModalData?.leavetype_id}
                    loading={handleSetLeaveType}
                    fieldLabel="leavetype_name"
                    autoFocus={false}
                    required={true}
                    variant={"outlined"}
                    name="leavetype_id"
                    size="small"
                    onChangeEvent={handleInputChange}
                    data={leaveTypesData}
                    {...(errors.leavetype_id && {
                      error: true,
                      helperText: errors.leavetype_id,
                    })}
                  />
                </FormControl>
              </Grid>
              <Grid
                key="to_lta"
                item
                xs={12}
                md={12}
                sx={{
                  marginTop: "15px",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                  cursor: "pointer",
                  color: "#0854ffcf",
                  textAlign: "right",
                }}
              >
                <div onClick={() => setOpensPopup(true)}>View Upcoming Holidays</div>
              </Grid>
            </Grid>

            <Grid container>
              <Grid
                key="from_date"
                item
                xs={12}
                md={6}
                sx={{
                  marginTop: "1.5rem",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                }}
              >
                <FormControl fullWidth>
                  <CommonDatePicker
                    disableDates={disableDates}
                    size="small"
                    name="from_date"
                    label="From Date"
                    pickerType="date"
                    onKeyPress={(e) => e.preventDefault()}
                    onKeyDown={(e) => e.preventDefault()}
                    required={true}
                    pickerFormat="dd/MM/yyyy"
                    DefaultDTvalue={leaveRequestModalData?.from_date}
                    minDate={
                        team_time_off
                          ? leaveRequestModalData?.employee_id?.doj
                            ? new Date(leaveRequestModalData.employee_id.doj)
                            : ""
                          : empData?.doj
                            ? new Date(empData.doj)
                            : ""
                    }
                    maxDate={
                      leaveRequestModalData?.to_date
                        ? new Date(leaveRequestModalData.to_date)
                        : ""
                    }
                    handleChange={(value) => {
                      calculateRequestedDate({
                        target: {
                          name: "from_date",
                          value: value
                            ? `${value?.getFullYear() +
                            "-" +
                            ("0" + (value?.getMonth() + 1)).slice(-2) +
                            "-" +
                            ("0" + value?.getDate()).slice(-2)
                            }`
                            : null,
                        },
                      });
                      calculateFromHoliday({
                        target: {
                          name: "from_date",
                          value: value
                            ? `${value?.getFullYear() +
                            "-" +
                            ("0" + (value?.getMonth() + 1)).slice(-2) +
                            "-" +
                            ("0" + value?.getDate()).slice(-2)
                            }`
                            : null,
                        },
                      });
                    }}
                    {...(errors.from_date && {
                      error: true,
                      helperText: errors.from_date,
                    })}
                  />
                </FormControl>
              </Grid>
              <Grid
                key="to_date"
                item
                xs={12}
                md={6}
                sx={{
                  marginTop: "1.5rem",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                }}
              >
                <FormControl fullWidth>
                  <CommonDatePicker
                    disableDates={disableDates}
                    size="small"
                    name="to_date"
                    label="To Date"
                    required={true}
                    pickerType="date"
                    onKeyPress={(e) => e.preventDefault()}
                    onKeyDown={(e) => e.preventDefault()}
                    pickerFormat="dd/MM/yyyy"
                    DefaultDTvalue={leaveRequestModalData?.to_date}
                    minDate={
                      leaveRequestModalData?.from_date
                        ? new Date(leaveRequestModalData.from_date)
                        : team_time_off
                            ? leaveRequestModalData?.employee_id?.doj
                              ? new Date(leaveRequestModalData.employee_id.doj)
                              : ""
                            : empData?.doj
                              ? new Date(empData.doj)
                              : ""
                    }
                    handleChange={(value) => {
                      calculateRequestedDate({
                        target: {
                          name: "to_date",
                          value: value
                            ? `${value?.getFullYear() +
                            "-" +
                            ("0" + (value?.getMonth() + 1)).slice(-2) +
                            "-" +
                            ("0" + value?.getDate()).slice(-2)
                            }`
                            : null,
                        },
                      });
                      calculateToHoliday({
                        target: {
                          name: "to_date",
                          value: value
                            ? `${value?.getFullYear() +
                            "-" +
                            ("0" + (value?.getMonth() + 1)).slice(-2) +
                            "-" +
                            ("0" + value?.getDate()).slice(-2)
                            }`
                            : null,
                        },
                      });
                    }}
                    {...(errors.to_date && {
                      error: true,
                      helperText: errors.to_date,
                    })}
                  />
                </FormControl>
              </Grid>

              <Grid
                key="is_from_half"
                item
                xs={12}
                md={6}
                sx={{
                  marginTop: "0.5rem",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                }}
              >
                {/* From Date Half-day hidden */}
              </Grid>
              <Grid
                key="is_to_half"
                item
                xs={12}
                md={6}
                sx={{
                  marginTop: "0.5rem",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                }}
              >
                {(() => {
                  const isSingleDay = Boolean(
                    leaveRequestModalData?.from_date &&
                    leaveRequestModalData?.to_date &&
                    leaveRequestModalData?.from_date === leaveRequestModalData?.to_date
                  );
                  return (
                    <Grid
                      sx={{ display: "flex", alignItems: "flex-start", visibility: isSingleDay ? "visible" : "hidden" }}
                      container
                    >
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          sx={{
                            ".MuiFormControlLabel-label": { fontSize: "15px" },
                          }}
                          control={
                            <Checkbox
                              size="small"
                              name="is_to_half"
                              checked={isSingleDay && Boolean(leaveRequestModalData?.is_to_half)}
                              onChange={calculateRequestedDate}
                              disabled={!isSingleDay}
                            />
                          }
                          label="Half-day"
                        />
                      </Grid>
                      {isSingleDay && leaveRequestModalData?.is_to_half && (
                        <Grid item xs={12} md={6}>
                          <FormControl>
                            <RadioGroup
                              onChange={handleInputChange}
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="is_to_half_value"
                              value={leaveRequestModalData.is_to_half_value}
                            >
                              {!toLeave?.firstHalf && (
                                <FormControlLabel
                                  value="First Half"
                                  control={<Radio size="small" />}
                                  label="First Half"
                                />
                              )}
                              {(!toLeave?.secondHalf && reqDays < 1) && (
                                <FormControlLabel
                                  value="Second Half"
                                  control={<Radio size="small" />}
                                  label="Second Half"
                                />
                              )}
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      )}
                    </Grid>
                  );
                })()}
              </Grid>
            </Grid>

            {!isCompOffSelected && <Grid container>
              <Grid
                key="leave_balance"
                item
                xs={12}
                md={6}
                sx={{
                  marginTop: "1.5rem",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                }}
              >
                <FormLabel sx={{ marginRight: "5px" }}>
                  Current Leave Balance
                </FormLabel>
                <FormControlLabel
                  sx={{ marginLeft: "2px" }}
                  control={
                    <Chip
                      label={
                        (leaveRequestModalData?.leavetype_id?.available_days ||
                          0) + " day(s)"
                      }
                      color="success"
                      variant="outlined"
                      size="small"
                    />
                  }
                  label="&nbsp;"
                />
              </Grid>
              <Grid
                key="lta_availed"
                item
                xs={12}
                md={6}
                sx={{
                  marginTop: "1.5rem",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                }}
              >
                <FormLabel sx={{ marginRight: "5px" }}>
                  Effective Leave
                </FormLabel>
                <FormControlLabel
                  sx={{ marginLeft: "2px" }}
                  control={
                    <Chip
                      label={isNaN(reqDays) || !(leaveRequestModalData?.from_date &&
                        leaveRequestModalData?.to_date) ? 0 + " day(s)" : reqDays + " day(s)"}
                      color="success"
                      variant="outlined"
                      size="small"
                    />
                  }
                  label="&nbsp;"
                />
              </Grid>
            </Grid>}
            <Grid container>
              <Grid
                key="note"
                item
                xs={12}
                md={12}
                sx={{
                  marginTop: "1.5rem",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                }}
              >
                {leaveRequestModalData?.leavetype_id?.is_unlimited && (
                  <SelectableSearch
                    label="Leave Reason"
                    value={leaveRequestModalData?.leave_reason}
                    loading={handleSetLeaveReason}
                    fieldLabel="reason_name"
                    autoFocus={false}
                    required={true}
                    variant={"outlined"}
                    name="leave_reason"
                    size="small"
                    onChangeEvent={handleInputChange}
                    data={leaveReasonData}
                    {...(errors.leave_reason && {
                      error: true,
                      helperText: errors.leave_reason,
                    })}
                  />
                )}
                <FormControl
                  fullWidth
                  sx={{
                    mt: leaveRequestModalData?.leavetype_id?.is_unlimited && 1,
                  }}
                >
                  <TextField
                    value={leaveRequestModalData?.note}
                    variant="outlined"
                    type={"text"}
                    fullWidth
                    required
                    onChange={handleInputChange}
                    id="note"
                    multiline
                    rows={
                      leaveRequestModalData?.leavetype_id?.is_unlimited
                        ? 1.8
                        : 4
                    }
                    label="Reason"
                    name="note"
                    error={Boolean(errors.note)}
                    helperText={errors.note}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Divider orientation="vertical" flexItem variant="middle" />
          <Grid item xs={12} md={4.8}>
            {!isCompOffSelected && leaveRequestModalData?.from_date &&
              leaveRequestModalData?.to_date && (
                <Box
                  sx={{
                    border: "1px solid grey",
                    borderRadius: "4px",
                    padding: "20px",
                    margin: "10px",
                  }}
                >
                  <Grid container>
                    <Grid mb={1} xs={12} md={8}>
                      <Typography>
                        As Of {ConvertDate(leaveRequestModalData?.from_date)} -{" "}
                        {ConvertDate(leaveRequestModalData?.to_date)}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      mb={1}
                      xs={12}
                      md={4}
                    >
                      <Typography>Days</Typography>
                    </Grid>

                    <Grid mb={1} xs={12} md={8}>
                      Balance before booking{" "}
                    </Grid>
                    <Grid
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      mb={1}
                      xs={12}
                      md={4}
                    >
                      {leaveRequestModalData?.leavetype_id?.available_days || 0}
                    </Grid>
                    <Grid mb={1} xs={12} md={8}>
                      This booking{" "}
                    </Grid>
                    <Grid
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      mb={1}
                      xs={12}
                      md={4}
                    >
                      {isNaN(reqDays) ? 0 : reqDays}
                    </Grid>
                    <Grid mb={1} xs={12} md={8}>
                      Balance after booking
                    </Grid>
                    <Grid
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      mb={1}
                      xs={12}
                      md={4}
                    >
                      {leaveRequestModalData?.leavetype_id?.available_days -
                        reqDays || 0}
                    </Grid>
                  </Grid>
                </Box>
              )}
            <Grid item textAlign={"center"}>
              <Typography variant="h6" sx={{ marginTop: "15px" }}>
                Summary
              </Typography>
              {(isCompOffSelected && daylist?.length > 0) && (
                <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1 }}>
                  Comp-Off leave requires selecting the earned holiday for every working day in the summary below. Only eligible holidays from the last two months are available.
                </Typography>
              )}
              
              <Box
                sx={{
                  padding: "5px",
                  mb: 2,
                  display: "flex",
                  flexDirection: "column",
                  height: 300,
                  overflow: "hidden",
                  overflowY: "auto",
                }}
              >
                {daylist?.map((res, index) => {
                  const key = res.toLocaleDateString();
                  const leave = empLeaveMap[key];

                  let statusText = "";
                  let isWorkingDay = false;

                  const holidayInfo = isHolidayDate(res);
                  if (holidayInfo) {
                    statusText = holidayInfo.statusText;
                  } else if (leave) {
                    statusText = (leave.full || (leave.firstHalf && leave.secondHalf))
                      ? "Applied (1)"
                      : (leave.firstHalf || leave.secondHalf)
                        ? "Applied (0.5)"
                        : "";
                  } else {
                    statusText = "Working Day";
                    isWorkingDay = true;
                  }

                  const tagColor = isWorkingDay ? "rgb(145, 85, 253)" : "rgb(46, 125, 50)";
                  const tagBg = isWorkingDay ? "rgba(145, 85, 253, 0.12)" : "rgba(46, 125, 50, 0.12)";

                  return (
                    <Box
                      key={index}
                      sx={{
                        padding: "5px",
                        paddingLeft: "35px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {monthNames[res?.getMonth()] + " " + res?.getDate()}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
                        <Box
                          sx={{
                            marginRight: "20px",
                            color: tagColor,
                            backgroundColor: tagBg,
                            padding: "0rem 0.25rem",
                            borderRadius: "10px",
                            textAlign: "center",
                          }}
                        >
                          <Typography fontWeight={600} fontSize="0.75rem" variant="subtitle1">
                            {statusText}
                          </Typography>
                        </Box>
                        {isCompOffSelected && (
                          isWorkingDay ? (
                            <Box sx={{ width: 180, }}>
                              <FormControl fullWidth>
                                <TextField
                                  select
                                  size="small"
                                  label="Comp-Off Earned On"
                                  value={
                                    leaveRequestModalData?.compoff_date_mapping_json?.[formatDateYMD(res)] || ""
                                  }
                                  onChange={(event) => {
                                    const selectedValue = event.target.value || null;
                                    handleWorkedDateChange(
                                      res,
                                      selectedValue ? new Date(selectedValue) : null
                                    );
                                  }}
                                  SelectProps={{
                                    MenuProps: {
                                      PaperProps: {
                                        sx: {
                                          maxHeight: 220,
                                        },
                                      },
                                    },
                                  }}
                                  InputProps={{
                                    ...(leaveRequestModalData?.compoff_date_mapping_json?.[formatDateYMD(res)] && {
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton
                                            size="small"
                                            onClick={() => handleWorkedDateChange(res, null)}
                                            edge="end"
                                            aria-label="clear selected holiday"
                                            sx={{ pr: 1.5 }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                    }),
                                  }}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: 32,
                                    },
                                    "& .MuiInputLabel-root": {
                                      fontSize: "13px",
                                    },
                                    "& .MuiSelect-select": {
                                      display: "flex",
                                      alignItems: "center",
                                      height: "32px",
                                      boxSizing: "border-box",
                                    },
                                  }}
                                >
                                  {getCompoffHolidayOptions(res)?.length > 0 ? (
                                    getCompoffHolidayOptions(res)?.map((option) => (
                                      <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem disabled value="">
                                      No eligible holiday available
                                    </MenuItem>
                                  )}
                                </TextField>
                              </FormControl>
                            </Box>
                          ) : (
                            <Box sx={{ width: 180, }} />
                          )
                        )}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
              {errors.compoff_date_mapping_json && (
                <Typography variant="caption" color="error" display="block" sx={{ mb: 1 }}>
                  {errors.compoff_date_mapping_json}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Box
          sx={{
            margin: "5px",
            marginRight: "15px",
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: "20px",
          }}
        >
          <Tooltip title={canBook ? "" : "You do not have enough leave balance to book this leave."}>
            <span>
              <Button
                size="small"
                variant="contained"
                className="mpl-primary-btn"
                onClick={handleConfirmationAlert}
                disabled={disableApply || !canBook}
              >
                Apply
              </Button>
            </span>
          </Tooltip>
        </Box>
      </div>
    </Box>
  );
};

export default ApplyLeave;
